import { useMemo } from "react";

/**
 * Returns whether the current page is rendered inside an iframe.
 *
 * Detection is performed once on mount by comparing `window.self` to
 * `window.top`. The comparison is wrapped in a try/catch because
 * cross-origin parent frames throw a security error on access, which
 * itself confirms we are inside an iframe.
 *
 * @returns `true` when running inside an iframe, `false` otherwise.
 */
export function useIsIframe(): boolean {
  return useMemo(() => {
    try {
      return window.self !== window.top;
    } catch {
      return true;
    }
  }, []);
}
